import { createContext } from "react";
import type { FilteredExercisesContextType } from "./FilteredExercisesContext.types";

const FilteredExercisesContext = createContext<FilteredExercisesContextType | undefined>(undefined);
FilteredExercisesContext.displayName = "FilteredExercisesContext";

export default FilteredExercisesContext;
